import PlanStore from '../stores/planStore'

const planStore = new PlanStore()

export default planStore
